module.exports = __webpack_public_path__ + "img/arrow.56d35767.svg";